module.exports = __webpack_public_path__ + "static/img/jquery.45a5b24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jquery.png
// module id = xhod
// module chunks = 0